export default function () {
  return {
    currentStep: 1,
    userType: null,
    basePlanId: null,
    hubPlanIds: [],
    dataPlanId: null,
    dataPlans: [],
    paymentMethodId: null,

    allPlans: [],
    companyPlans: [],
    isTrialAllowed: false,
    companyType: null,

    paymentMethods: [],
    loading: true,
    companyLicenses: [],
    licenseCategory: "unknown",
  };
}
